export default "__VITE_ASSET__DyM$SmOn__"